import { SvgIcon } from '@bob/library'
import { Markdown } from '@websrc/App/Components/Markdown/Markdown'
import React from 'react'

import * as SC from './ChokingHazard.style'

export interface ChokingHazardProps {
  warningText: string
}

export const ChokingHazard = ({ warningText }: ChokingHazardProps) => {
  return (
    <SC.Wrapper>
      <SC.IconWrapper>
        <SvgIcon
          color={'black'}
          colors={[{ colorName: 'yellow', property: 'fill', index: 0 }]}
          name={'WARNING'}
          size={45}
        />
      </SC.IconWrapper>
      <SC.TextWrapper>
        <Markdown markdown={warningText} />
      </SC.TextWrapper>
    </SC.Wrapper>
  )
}
